module.exports = __webpack_public_path__ + "img/buzou3.71e41133.png";